const createCheckoutSessionErrorMutation = (state, payload) => {
  state.createCheckoutSessionError = payload
}
const hookBulkPricingErrorMutation = (state, payload) => {
  state.hookBulkPricingError = payload
}
const isCreatingCheckoutSession = (state, payload) => {
  state.isCreatingCheckoutSession = payload
}
const isCreatingCustomerPortal = (state, payload) => {
  state.isCreatingCustomerPortal = payload
}
const loadingPlan = (state, payload) => {
  state.loadingPlan = payload
}
const setRemoveCardPurpose = (state, payload) => {
  state.isRemoveCardPurpose = payload
}
const setPromotionCode = (state, payload) => {
  state.promotionCode = payload
}
const setIsValidPromoCode = (state, payload) => {
  state.isValidPromoCode = payload
}

const isShowingRequestAdditionalLicensePopup = (state, payload) => {
  state.isShowingRequestAdditionalLicensePopup = payload
}

const setMonthlyToYearlyUpgradePreview = (state, payload) => {
  state.monthlyToYearlyUpgradePreview = payload
}

const setUpgradingFromMonthlyToYearly = (state, payload) => {
  state.isUpgradingFromMonthlyToYearly = payload
}

const setIsShowMonthlyToYearlyPromoBanner = (state, payload) => {
  state.isShowMonthlyToYearlyPromoBanner = payload
}

export default {
  createCheckoutSessionErrorMutation,
  hookBulkPricingErrorMutation,
  isCreatingCheckoutSession,
  isCreatingCustomerPortal,
  setRemoveCardPurpose,
  loadingPlan,
  isShowingRequestAdditionalLicensePopup,
  setPromotionCode,
  setIsValidPromoCode,
  setMonthlyToYearlyUpgradePreview,
  setUpgradingFromMonthlyToYearly,
  setIsShowMonthlyToYearlyPromoBanner,
}
